import React from 'react'

const Chip = ({status}) => {
    return (
        <div className={`chip ml-3 ${status === 'Active' ? 'chip-active' : 'chip-inactive'}`}>
            <div class="chip-content">{status}</div>
        </div>
    )
}

export default Chip